import { App, Button, Drawer } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import HistoryPredictions from 'components/HistoryPredictions';
import VoteAuthModal from 'components/Home/resultPredictionBoard/VoteAuthModal';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authClientSignIn, getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';
import BannerSlider from './BannerSlider';
import { LocalStorageKey } from 'utils/common/const';
import { setAuthorizationBase } from 'config/axiosBase';

const navItems = [
  {
    href: '/',
    icon: '/assets/images/header/btn_dudoan.png',
    iconActive: '/assets/images/header/btn_dudoan_active.png'
  },
  {
    href: '/rule',
    icon: '/assets/images/header/btn_thele.png',
    iconActive: '/assets/images/header/btn_thele_active.png'
  },
  {
    href: '/prize-structure',
    icon: '/assets/images/header/btn_ketqua.png',
    iconActive: '/assets/images/header/btn_ketqua_active.png'
  },
  {
    href: '/history',
    icon: '/assets/images/header/btn_lichsu.png',
    iconActive: '/assets/images/header/btn_lichsu_active.png'
  }
];

const HeaderMenu = ({ onHistoryClick, onPredictClick, homeView = 'predict' }) => {
  const { notification } = App.useApp();
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const navigate = useNavigate();
  const activeNav = location.pathname;
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [clientSigninUsername, setClientSigninUsername] = useState(
    localStorage.getItem('client_signin_username') || ''
  );
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isSigninPopupOpen, setIsSigninPopupOpen] = useState(false);
  const [accountName, setAccountName] = useState('');
  const [bankLastFourDigits, setBankLastFourDigits] = useState('');
  const [isSubmittingVote, setIsSubmittingVote] = useState(false);
  const [shouldOpenHistoryAfterSignin, setShouldOpenHistoryAfterSignin] = useState(false);
  const bankDigitRefs = useRef([]);
  const isHomeRoute = activeNav === '/';
  const isHistoryTabActive = activeNav === '/history' || (isHomeRoute && homeView === 'history');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({ site: CONST_SITE.QQ88 });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    const handleClientSigninUpdated = () => {
      setClientSigninUsername(localStorage.getItem('client_signin_username') || '');
      setShowUserMenu(false);
    };

    window.addEventListener('client-signin-updated', handleClientSigninUpdated);
    return () => window.removeEventListener('client-signin-updated', handleClientSigninUpdated);
  }, []);

  useEffect(() => {
  const handleOpenSigninPopupEvent = () => {
    setIsShowMenu(false);
    setTimeout(() => {
      handleOpenSigninPopup();
    }, 150);
  };

  window.addEventListener('open-client-signin-popup', handleOpenSigninPopupEvent);

  return () => {
    window.removeEventListener('open-client-signin-popup', handleOpenSigninPopupEvent);
  };
}, [clientSigninUsername]);

  const handleLogoutClientSignin = () => {
    localStorage.removeItem('client_signin_username');
    localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
    setClientSigninUsername('');
    setShowUserMenu(false);
    window.dispatchEvent(new Event('client-signin-updated'));
  };

  const handleBankDigitChange = (idx, value) => {
    const digit = value.replace(/\D/g, '').slice(-1);
    const nextDigits = bankLastFourDigits.split('');
    while (nextDigits.length < 4) nextDigits.push('');
    nextDigits[idx] = digit;
    setBankLastFourDigits(nextDigits.join('').slice(0, 4));

    if (digit && idx < 3) {
      bankDigitRefs.current[idx + 1]?.focus();
    }
  };

  const handleBankDigitKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !bankLastFourDigits[idx] && idx > 0) {
      bankDigitRefs.current[idx - 1]?.focus();
    }
  };

  const handleOpenSigninPopup = () => {
    setAccountName(clientSigninUsername || '');
    setBankLastFourDigits('');
    setIsSigninPopupOpen(true);
  };

  const handleCloseSigninPopup = () => {
    if (isSubmittingVote) return;
    setIsSigninPopupOpen(false);
    setShouldOpenHistoryAfterSignin(false);
    setAccountName('');
    setBankLastFourDigits('');
  };

  const handleConfirmSigninPopup = async () => {
    const username = accountName.trim();
    const lastbank = bankLastFourDigits.trim();

    if (!username) {
      notification.warning({ message: 'Cảnh báo', description: 'Vui lòng nhập tên tài khoản.' });
      return;
    }

    if (!/^\d{4}$/.test(lastbank)) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập đúng 4 số cuối tài khoản ngân hàng.'
      });
      return;
    }

    try {
      setIsSubmittingVote(true);
      const res = await authClientSignIn({ username, lastbank, site: 'qq88' });

      if (res?.code === 0 || res?.success === true) {
        const userToken =
          res?.userToken ||
          res?.token ||
          res?.accessToken ||
          res?.data?.userToken ||
          res?.data?.token;

        localStorage.setItem('client_signin_username', username);
        if (userToken) {
          localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, String(userToken));
          setAuthorizationBase(String(userToken));
        }

        setClientSigninUsername(username);
        setShowUserMenu(false);
        setIsShowMenu(false);
        if (shouldOpenHistoryAfterSignin) {
          setShouldOpenHistoryAfterSignin(false);
          if (typeof onHistoryClick === 'function') {
            onHistoryClick();
          } else {
            navigate('/history');
          }
        }
        handleCloseSigninPopup();
        window.dispatchEvent(new Event('client-signin-updated'));
        notification.success({
          message: 'Thành công',
          description: 'Kiểm tra tài khoản thành công.'
        });
        return;
      }

      notification.error({
        message: 'Lỗi',
        description: res?.message || res?.text_mess || 'Gửi thông tin thất bại.'
      });
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error?.message || 'Không thể kết nối đến máy chủ.'
      });
    } finally {
      setIsSubmittingVote(false);
    }
  };

  const handlePredictAction = () => {
    setIsModalHistory(false);
    setShouldOpenHistoryAfterSignin(false);
    if (typeof onPredictClick === 'function') {
      onPredictClick();
    }
  };

  const handleHistoryAction = () => {
    setIsModalHistory(false);
    const isSignedIn = Boolean(clientSigninUsername?.trim());
    if (!isSignedIn) {
      setShouldOpenHistoryAfterSignin(true);
      handleOpenSigninPopup();
      setIsShowMenu(false);
      return;
    }

    setShouldOpenHistoryAfterSignin(false);
    if (typeof onHistoryClick === 'function') {
      onHistoryClick();
      setIsShowMenu(false);
      return;
    }
    navigate('/history');
    setIsShowMenu(false);
  };

  return (
    <div className="w-full">
      <div className="w-full bg-[#006719]">
        <div className="flex flex-row justify-between items-center w-full max-w-[1200px] mx-auto px-[8px] md:px-[26px] py-[8px] md:py-[13px] gap-[5px] md:gap-[10px] h-[60px] md:h-[80px] overflow-visible">
          <div className="flex md:hidden justify-start w-full md:w-1/5">
            <Drawer
              placement="left"
              onClose={() => setIsShowMenu(false)}
              open={isShowMenu}
              closeIcon={null}
              width={260}
              bodyStyle={{ padding: 0, position: 'relative' }}
              style={{ overflow: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              className="drawer-hide-scrollbar"
            >
              <style>
                {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;
                    -ms-overflow-style: none !important;
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
              </style>

              <div
                className="flex items-center justify-center w-full py-6 border-b border-gray-200"
                style={{ background: '#006719' }}
              >
                <Link
                  to="/"
                  onClick={() => {
                    handlePredictAction();
                    setIsShowMenu(false);
                  }}
                >
                  <img
                    src="/assets/images/header/logo.png"
                    alt="Logo"
                    className="h-[48px] w-auto object-contain mx-auto"
                  />
                </Link>
              </div>

              <button
                onClick={() => setIsShowMenu(false)}
                className="absolute top-3 right-3 z-10 text-gray-200 hover:text-white transition-colors"
                aria-label="Ðóng menu"
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: 32,
                  lineHeight: 1,
                  cursor: 'pointer'
                }}
              >
                ×
              </button>

              <div
                className="flex flex-col h-full"
                style={{ background: '#006719', overflow: 'auto' }}
              >
                <div className="flex flex-col">
                  <Link
                    to="/"
                    onClick={() => {
                      handlePredictAction();
                      setIsShowMenu(false);
                    }}
                    className="flex items-center px-5 py-4 border-b border-green-900 hover:bg-green-800 hover:text-yellow-300 font-bold text-xl text-white transition-colors"
                  >
                    Dự đoán
                  </Link>
                  <Link
                    to="/rule"
                    onClick={() => {
                      setIsModalHistory(false);
                      setIsShowMenu(false);
                    }}
                    className="flex items-center px-5 py-4 border-b border-green-900 hover:bg-green-800 hover:text-yellow-300 font-bold text-xl text-white transition-colors"
                  >
                    Thể lệ
                  </Link>
                  <Link
                    to="/prize-structure"
                    onClick={() => {
                      setIsModalHistory(false);
                      setIsShowMenu(false);
                    }}
                    className="flex items-center px-5 py-4 border-b border-green-900 hover:bg-green-800 hover:text-yellow-300 font-bold text-xl text-white transition-colors"
                  >
                    Kết quả
                  </Link>
                  <Button
                    type="text"
                    className="flex items-center justify-start px-5 py-8 font-bold text-xl w-full text-left text-white transition-colors group"
                    onClick={handleHistoryAction}
                    style={{ color: '#fff', background: 'transparent', border: 'none' }}
                  >
                    <span className="group-hover:text-yellow-300 group-hover:bg-green-800 w-full block transition-colors">
                      Lịch sử
                    </span>
                  </Button>
                  {!clientSigninUsername && (
                    <>
                      <button
                        type="button"
                        className="flex items-center rounded-[12px] px-4 py-3 hover:bg-green-800 hover:text-yellow-300 font-bold text-xl text-white transition-colors border-0 bg-transparent text-left"
                        onClick={() => {
                          setIsModalHistory(false);
                          handleOpenSigninPopup();
                          setIsShowMenu(false);
                        }}
                      >
                        Đăng nhập
                      </button>
                      <Link
                        to={settings.link_register}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-1 flex items-center rounded-[12px] px-4 py-3 hover:bg-green-800 hover:text-yellow-300 font-bold text-xl text-white transition-colors"
                        onClick={() => setIsModalHistory(false)}
                      >
                        Đăng ký
                      </Link>
                    </>
                  )}

                  <div className="mt-auto px-4 pb-2 pt-0">
                    {clientSigninUsername ? (
                      <div className="mb-2  px-4 py-4 rounded-2xl border border-[#8cb6d8] bg-gradient-to-b from-[#f4f8ff] to-[#e6eef8]">
                        <div className="text-[18px] text-[#000000]">Xin chào,</div>
                        <div className="mt-1 truncate text-[30px] font-semibold leading-none text-[#000000]">
                          {clientSigninUsername}
                        </div>
                        <button
                          type="button"
                          onClick={handleLogoutClientSignin}
                          className="mt-4 w-full cursor-pointer rounded-[14px] border-0 bg-white px-4 py-3 text-left text-[16px] font-semibold text-[#102641] shadow-[0_6px_14px_rgba(0,0,0,0.2)]"
                        >
                          Đăng xuất
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </Drawer>

            <Button type="link" onClick={() => setIsShowMenu(true)}>
              <img
                src="/assets/images/header/menu.png"
                alt="Menu"
                className="h-[32px] w-[32px] md:w-auto object-contain"
              />
            </Button>
          </div>

          <div className="flex justify-start w-full mt-2">
            <Link to="/">
              <img
                src="/assets/images/header/logo.png"
                alt="Logo"
                className="h-[52px] md:h-[72px] w-auto object-contain"
              />
            </Link>
          </div>

          <div
            className="relative flex justify-end items-center w-full hide-scrollbar overflow-visible"
            style={{ height: '100%', overflow: 'visible' }}
          >
            <style>
              {`
                .hide-scrollbar {
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                }
                .hide-scrollbar::-webkit-scrollbar {
                  display: none;
                  width: 0 !important;
                  background: transparent !important;
                }
              `}
            </style>

            <Link
              to={settings.link_home}
              target="_blank"
              className="md:hidden w-[90px] h-[90px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/home.png"
                alt="Trang chủ"
                className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
            {!clientSigninUsername && (
              <div className="hidden md:flex flex-row items-center justify-end gap-2 w-full h-full">
                <button
                  type="button"
                  className="cursor-pointer text-[18px] flex items-center rounded-full px-4 py-1 bg-white hover:scale-105 hover:-translate-y-1 hover:shadow-lg font-semibold text-[#11833c] transition-colors border-0 bg-transparent text-left"
                  onClick={() => {
                    setIsModalHistory(false);
                    handleOpenSigninPopup();
                  }}
                >
                  Đăng nhập
                </button>
                <Link
                  to={settings.link_register}
                  target="_blank"
                  className="w-[90px] h-[26px] md:w-[118px] md:h-[33px] flex items-center justify-center"
                >
                  <img
                    src="/assets/images/header/register.png"
                    alt="Ðang ký"
                    className="max-w-full max-h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
                  />
                </Link>
              </div>
            )}
            {clientSigninUsername ? (
              <div className="hidden md:flex w-auto justify-end">
                <div
                  onClick={() => setShowUserMenu((prev) => !prev)}
                  className="relative z-50 flex cursor-pointer items-center gap-3 rounded-full border border-[#8cb6d8] bg-gradient-to-b from-[#f4f8ff] to-[#e6eef8] px-4 py-1 shadow-[inset_0_1px_0_#ffffff]"
                >
                  <div className="text-left leading-tight">
                    <div className="text-[12px] text-[#6f7f93]">Xin chào</div>
                    <div className="max-w-[120px] truncate text-[18px] font-bold text-[#102641]">
                      {clientSigninUsername}
                    </div>
                  </div>
                  <div className="flex h-[42px] w-[42px] items-center justify-center rounded-full bg-[#006719] text-white">
                    <UserOutlined className="text-[18px]" />
                  </div>
                  <DownOutlined
                    className={`text-[12px] text-[#2c3e57] transition-transform ${
                      showUserMenu ? 'rotate-180' : ''
                    }`}
                  />
                  {showUserMenu ? (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLogoutClientSignin();
                      }}
                      className="absolute right-0 top-[calc(100%+8px)] z-[70] w-[160px] cursor-pointer rounded-[16px] border-0 bg-white px-4 py-3 text-left text-[16px] font-semibold text-[#102641] outline-none shadow-[0_8px_20px_rgba(0,0,0,0.2)]"
                    >
                      Đăng xuất
                    </button>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <BannerSlider />

      <div className="hidden md:flex flex-row justify-center items-center w-full gap-2 sm:gap-4 lg:gap-6 md:py-3 bg-white py-2">
        {navItems.map((item) => {
          const isActive =
            item.href === '/'
              ? isHomeRoute && !isHistoryTabActive
              : item.href === '/history'
                ? isHistoryTabActive
                : activeNav === item.href;

          if (item.href === '/history') {
            return (
              <button
                key={item.href}
                type="button"
                onClick={handleHistoryAction}
                className="text-center min-w-[68px] text-[10px] md:text-[14px] font-semibold flex items-center justify-center transition-colors duration-200 w-auto h-[50px] bg-transparent border-none cursor-pointer"
              >
                <img
                  src={isActive ? item.iconActive : item.icon}
                  alt="Lịch sử"
                  className="w-full h-full object-contain"
                />
              </button>
            );
          }

          return (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => {
                if (item.href === '/') {
                  handlePredictAction();
                  return;
                }
                setIsModalHistory(false);
              }}
              className="text-center min-w-[68px] text-[10px] md:text-[14px] font-semibold flex items-center justify-center transition-colors duration-200 w-auto h-[50px] bg-transparent"
            >
              <img
                src={isActive ? item.iconActive : item.icon}
                alt="Menu"
                className="w-full h-full object-contain"
              />
            </Link>
          );
        })}
      </div>

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={''}
        FP={''}
      />

      <VoteAuthModal
        open={isSigninPopupOpen}
        accountName={accountName}
        bankLastFourDigits={bankLastFourDigits}
        bankDigitRefs={bankDigitRefs}
        isSubmittingVote={isSubmittingVote}
        onAccountNameChange={setAccountName}
        onBankDigitChange={handleBankDigitChange}
        onBankDigitKeyDown={handleBankDigitKeyDown}
        onClose={handleCloseSigninPopup}
        onConfirm={handleConfirmSigninPopup}
      />
    </div>
  );
};

export default HeaderMenu;
